export const CurrentClientUserDependencyTypes = {
  CurrentClientUserApiService: Symbol.for('CurrentClientUserApiService'),
  CurrentClientUserRepository: Symbol.for('CurrentClientUserRepository'),
  CurrentClientUserService: Symbol.for('CurrentClientUserService'),
  CurrentClientUserSelectionService: Symbol.for('CurrentClientUserSelectionService'),
  CurrentClientUserSelectionRepository: Symbol.for('CurrentClientUserSelectionRepository'),
  CurrentClientUserSelectionLocalStorageService: Symbol.for('CurrentClientUserSelectionLocalStorageService'),
  CurrentClientUserSelectedClientService: Symbol.for('CurrentClientUserSelectedClientService'),
  CurrentClientUserSelectedClientGamesReloaderService: Symbol.for(
    'CurrentClientUserSelectedClientGamesReloaderService',
  ),
  CurrentClientUserStoreQuery: Symbol.for('CurrentClientUserStoreQuery'),
  CurrentClientUserStoreCommand: Symbol.for('CurrentClientUserStoreCommand'),
  CurrentClientUserApiDataTransformer: Symbol.for('CurrentClientUserApiDataTransformer'),
  CurrentClientUserClientApiDataTransformer: Symbol.for('CurrentClientUserClientApiDataTransformer'),
};
